import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { SIGNAL_ITEM_KEY } from 'src/app/extensions/constants/commonConstants';
import { DictionaryClientDataRequestType } from 'src/app/extensions/constants/dictionaryConstants/dictionaryConstants';
import { DictionaryAPIService } from 'src/app/extensions/services/api/dictionary-api.service';
import { PartnerAPIService } from 'src/app/extensions/services/api/partner-api.service';
import { GlobalService } from 'src/app/extensions/services/global.service';
import { isNotEmpty } from 'src/app/extensions/utilities';

@Component({
  selector: 'app-add-contact-information',
  templateUrl: './add-contact-information.component.html',
  styleUrls: ['./add-contact-information.component.scss'],
  standalone: false,
})
export class AddContactInformationRequestComponent implements OnInit {
  @ViewChild('form') public form: NgForm;

  isSendButtonDisabled: boolean = true;
  isPJ: boolean;
  isDataLoaded: boolean = false;

  clientDataRequestSaveModel: app.models.ClientDataRequestSaveModel = {
    contactInformation: {},
    documentsAttached: [],
  } as app.models.ClientDataRequestSaveModel;

  private stateSignalItem: any;

  constructor(
    private _globalService: GlobalService,
    private _router: Router,
    private _dictionaryService: DictionaryAPIService,
    private _partnerService: PartnerAPIService,
    private _activatedRoute: ActivatedRoute
  ) {
    this.stateSignalItem = this._globalService.getSignalItem(SIGNAL_ITEM_KEY.RQST_CLIENT_DATA);

    if (isNotEmpty(this.stateSignalItem)) {
      this.clientDataRequestSaveModel = this.stateSignalItem.data as app.models.ClientDataRequestSaveModel;
      this.isPJ = this.stateSignalItem.extras?.isPJ;
      this.isSendButtonDisabled = this.stateSignalItem.extras?.isSendButtonDisabled;
      this.isDataLoaded = this.stateSignalItem.extras?.isDataLoaded;
    }
  }

  ngOnInit(): void {
    if (!isNotEmpty(this.stateSignalItem)) {
      this.loadData();
    }
  }

  loadData() {
    let source = forkJoin([this._partnerService.getCompanyInfo(), this._dictionaryService.getClientDataRequestTypes()]);
    source.subscribe(([clientData, dictionaryClientDataRequestTypes]) => {
      if (clientData.data) {
        this.isPJ = clientData.data.isPJ;
        this.clientDataRequestSaveModel.partnerExternalEntityId = clientData.data.partnerExternalEntityId;
        this.clientDataRequestSaveModel.contactInformation = {
          email: clientData.data.email,
          phone: clientData.data.phone,
          fax: clientData.data.fax,
        } as app.models.ClientDataRequestsContactInformationModel;
      }

      if (dictionaryClientDataRequestTypes.data) {
        let contactInformationRequestType = dictionaryClientDataRequestTypes.data.find(
          x => x.code == DictionaryClientDataRequestType.ContactInformation
        );
        if (contactInformationRequestType) {
          this.clientDataRequestSaveModel.dictionaryClientDataRequestTypeId = contactInformationRequestType.id;
          this.clientDataRequestSaveModel.description = contactInformationRequestType.description;
          this.isSendButtonDisabled = false;
        }
      }
      this.isDataLoaded = true;
    });
  }

  sendRequestCofirmationHandler() {
    if (this.form.invalid) {
      return;
    }

    this.stateSignalItem = {
      data: this.clientDataRequestSaveModel,
      extras: {
        isPJ: this.isPJ,
        isSendButtonDisabled: this.isSendButtonDisabled,
        isDataLoaded: this.isDataLoaded,
      },
      routePath: this._activatedRoute.snapshot.routeConfig.path,
    };
    this._globalService.setSignalItem(SIGNAL_ITEM_KEY.RQST_CLIENT_DATA, this.stateSignalItem);
    this._router.navigate(['requests/client-data/new/request-preview']);
  }

  redirectListHandler = () => {
    this._router.navigate(['requests/client-data']);
  };

  redirectFieldSelectionHandler() {
    this._router.navigate(['requests/client-data/new']);
  }
}
